export default __webpack_public_path__ + "static/typography-image-s-27e10cf7b725f381c134987145f7c66be015c5bfb5b36ac9beadbea0968e3293.png";